import React, { Fragment, useState, useEffect } from 'react';
import { Disclosure, Menu, Transition } from '@headlessui/react';
import { MenuIcon as Bars3Icon, XIcon as XMarkIcon } from '@heroicons/react/outline';
import ima from './imasm.svg';
import ga from './galle.png';
import { useHistory, Link } from 'react-router-dom';
import ApiService from './services/apiservice';

const user = {
  name: 'Administrador',
  email: ['adminnavi@gmail.com','ricardoramirez@sanmartinbakery.com'],
  image: ima,
  imag: ga
};

const navigation = [
  { name: 'Guatemala', current: true },
  { name: 'El Salvador', Link: '/navideño-admin-sv', current: false }
];

const userNavigation = [
  { name: 'Cerrar Sesión', href: '#/login' },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Example() {
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const history = useHistory();

  const handleLogout = () => {
    localStorage.removeItem('session');
    setIsAuthenticated(false);
    history.push('/login');
  };

  const apiService = new ApiService();
  const [canjesPorFecha, setCanjesPorFecha] = useState([]);
  const [usuariosRegistradosPorFecha, setgetCanjesPorFecha] = useState([]);
  const [totalCanjes, setTotalCanjes] = useState(0);
  const [totalUsuarios, setTotalUsuarios] = useState(0);

  useEffect(() => {
    async function fetchData() {
      try {
        const responseCanjes = await apiService.getCanjesPorFecha(1);
        setCanjesPorFecha(responseCanjes.canjesPorFecha);
        calcularTotalCanjes(responseCanjes.canjesPorFecha);

        const responseUsuarios = await apiService.getCanjesPorFecha(1);
        setgetCanjesPorFecha(responseUsuarios.usuariosRegistradosPorFecha);
        calcularTotalUsuarios(responseUsuarios.usuariosRegistradosPorFecha);
      } catch (error) {
        console.error('Error al obtener los datos:', error);
      }
    }

    fetchData();
  }, []);

  const calcularTotalCanjes = (data) => {
    const total = data
      .filter((canje) => canje.fecha !== null)
      .reduce((acc, item) => acc + item.cantidad_canjes, 0);
    setTotalCanjes(total);
  };

  const calcularTotalUsuarios = (data) => {
    const total = data
      .filter((usuario) => usuario.fecha !== null)
      .reduce((acc, item) => acc + item.cantidad_usuarios, 0);
    setTotalUsuarios(total);
  };


  return (
    <>
      <div className="min-h-full">
        <Disclosure as="nav" className="border-b border-gray-200 bg-white bg-opacity-75">
          {({ open }) => (
            <>
              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="flex h-16 justify-between">
                  <div className="flex">
                    <div className="flex flex-shrink-0 items-center">
                      <Link to="/home">
                        <div className="flex flex-shrink-0 items-center">
                          <img
                            className="block h-8 w-auto lg:hidden rounded bg-blue-900"
                            src={user.image}
                            alt={user.name}
                          />
                          <img
                            className="hidden h-8 w-auto lg:block rounded-full bg-blue-900"
                            src={user.image}
                            alt={user.name}
                          />
                        </div>
                      </Link>
                    </div>
                    <div className="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
                      {navigation.map((item) => (
                        <Link
                          key={item.name}
                          to={item.Link}
                          className={classNames(
                            item.current
                              ? 'border-indigo-500 text-gray-900'
                              : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                            'inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium'
                          )}
                          aria-current={item.current ? 'page' : undefined}
                        >
                          {item.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                  <div className="hidden sm:ml-6 sm:flex sm:items-center">

                    {/* Profile dropdown */}
                    <Menu as="div" className="relative ml-3">
                      <div>
                        <Menu.Button className="relative flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                          <span className="absolute -inset-1.5" />
                          <span className="sr-only">Open user menu</span>
                          <img className="h-8 w-8 rounded-full bg-blue-900" src={user.imag} alt={user.name} />

                        </Menu.Button>
                      </div>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          {userNavigation.map((item) => (
                            <Menu.Item key={item.name}>
                              {({ active }) => (
                                <Link
                                  to={item.href}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleLogout();
                                  }}
                                  className={classNames(
                                    active ? 'bg-gray-100' : '',
                                    'block px-4 py-2 text-sm text-gray-700'
                                  )}
                                >
                                  {item.name}
                                </Link>
                              )}
                            </Menu.Item>
                          ))}


                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                  <div className="-mr-2 flex items-center sm:hidden">
                    {/* Mobile menu button */}
                    <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                      <span className="absolute -inset-0.5" />
                      <span className="sr-only">Open main menu</span>
                      {open ? (
                        <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                      ) : (
                        <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                      )}
                    </Disclosure.Button>
                  </div>
                </div>
              </div>
              <Disclosure.Panel className="sm:hidden">
                <div className="space-y-1 pb-3 pt-2">
                  {navigation.map((item) => (
                    <Disclosure.Button
                      key={item.name}
                      as={Link}
                      to={item.Link}
                      className={classNames(
                        item.current
                          ? 'border-indigo-500 bg-indigo-50 text-indigo-700'
                          : 'border-transparent text-gray-600 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-800',
                        'block border-l-4 py-2 pl-3 pr-4 text-base font-medium'
                      )}
                      aria-current={item.current ? 'page' : undefined}
                    >
                      {item.name}
                    </Disclosure.Button>
                  ))}
                </div>
                <div className="border-t border-gray-200 pb-3 pt-4">
                  <div className="flex items-center px-4">
                    <div className="flex-shrink-0">
                      <img className="h-10 w-10 rounded-full bg-blue-900" src={user.imag} alt="" />
                    </div>
                    <div className="ml-3">
                      <div className="text-base font-medium text-gray-800">{user.name}</div>
                      <div className="text-sm font-medium text-gray-500">{user.email}</div>
                    </div>
                  </div>
                  <div className="mt-3 space-y-1">
                    {userNavigation.map((item) => (
                      <Disclosure.Button
                        key={item.name}
                        onClick={(e) => {
                          e.preventDefault();
                          handleLogout();
                        }}
                        className="block mx-auto px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800"
                      >
                        {item.name}
                      </Disclosure.Button>
                    ))}
                  </div>
                </div>
              </Disclosure.Panel>

            </>
          )}
        </Disclosure>

        <div className="py-10">
          <header>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
              <h1 className="text-3xl font-bold leading-tight tracking-tight text-white">Dashboard Guatemala</h1>
            </div>
          </header>
          <main className='px-3'>
            <div className="mx-auto max-w-7xl sm:px-6 lg:px-8 py-10">
              <div className="px-4 sm:px-6 lg:px-8 bg-white rounded-lg overflow-hidden shadow-md">
                <div className="sm:flex sm:items-center">
                </div>
                <div className="mt-8 flow-root">
                  <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                      <table className="min-w-full divide-y divide-gray-300">
                        <thead>
                          <tr>
                            <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 text-center">
                              Fecha </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-center">
                              Usuarios Creados </th>
                            <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 text-center">
                              Cupones de Canjeados </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                          {canjesPorFecha
                            .filter((canje) => canje.fecha !== null)
                            .map((canje, index) => {
                              const usuarioPorFecha = usuariosRegistradosPorFecha.find(usuario => usuario.fecha === canje.fecha);
                              return (
                                <tr key={index}>
                                  <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                                    {canje.fecha || 'Sin fecha'}
                                  </td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                    {usuarioPorFecha ? usuarioPorFecha.cantidad_usuarios : 0}
                                  </td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                    {canje.cantidad_canjes}
                                  </td>
                                </tr>
                              );
                            })}

                          <tr>
                            <td className="whitespace-nowrap px-3 py-4 text-m text-black font-semibold ">
                              Totales </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-black font-semibold">
                              {totalUsuarios} </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-black font-semibold">
                              {totalCanjes} </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </main>
        </div>
      </div>
    </>
  )
}